module.exports = __webpack_public_path__ + "static/media/Rayya Creativa.e24fd008.png";